module.exports = __webpack_public_path__ + "img/part7_x1.385d0083.png";